var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarY = function SvgDefaultAvatarY(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 55.3c4.5 0 6.8-.4 6.8-1.6 0-.9-1-1.2-3.4-1.3-.6-.2-.8-2.1-.8-4.5v-5.7c.4-1 .9-2 1.9-3.5 4.7-7 6.5-10 8.1-10.8 2.3-.2 3.2-.6 3.2-1.3 0-1-2.1-1.6-5.8-1.6-3.9 0-6.3.5-6.3 1.6 0 .8.9 1.1 3.3 1.3.5.2.4.6 0 1.5-1.3 2.6-4.1 6.9-5.9 9.4-1.8-2.2-5-6.9-6-9.1-.5-1.1-.6-1.6-.3-1.7 2.1-.1 3-.5 3-1.3 0-1-2.1-1.7-6.6-1.7-4.6 0-6.9.6-6.9 1.8 0 .8.8 1.1 2.9 1.3 1.5.9 2.9 2.9 8.6 11.2.9 1.3 1.4 2.2 1.8 3.2V48c0 2.4-.2 4.3-.8 4.5-2.5.1-3.5.4-3.5 1.3-.1 1 2.3 1.5 6.7 1.5z"
  })));
};
export default SvgDefaultAvatarY;